import { createContext } from 'react';
import { QUERY_KEYS_CIHA, useChartsData } from '../../Common/hooks/useChartsData';
import { useCIHAFiltersContext } from '../../Common/Filters/hooks/useCIHAFiltersContext';

export const EstablishmentLocationChartsDataContext = createContext();

const EstablishmentLocationChartsDataProvider = ({ children }) => {
    const { filters } = useCIHAFiltersContext();
    const currentYear = new Date().getFullYear();
    const filterParams = {
        cnes: filters.unidade?.value,
        ano: filters.year?.value || currentYear,
        mes: filters.month?.value
    };
    
    const cityFilterParams = {
        cidade: filters.cidade?.value,
        ano: filters.year?.value || currentYear,
        mes: filters.month?.value
    };

    const topCnes = useChartsData(
        {
            key: QUERY_KEYS_CIHA.LOCATION_TOP_CNES,
            url: 'governanceroom/cihadashboard/locationTopCnes'
        },
        cityFilterParams,
        false
    );

    const managementByYear = useChartsData(
        {
            key: QUERY_KEYS_CIHA.LOCATION_MANAGEMENT_BY_YEAR,
            url: 'governanceroom/cihadashboard/locationManagementByYear'
        },
        {
            cnes: filters.unidade?.value,
            mes: filters.month?.value
        }
    );

    const byNature = useChartsData(
        {
            key: QUERY_KEYS_CIHA.LOCATION_BY_NATURE,
            url: 'governanceroom/cihadashboard/locationByNature'
        },
        filterParams,
    );

    const topMunicipalities = useChartsData(
        {
            key: QUERY_KEYS_CIHA.LOCATION_TOP_MUNICIPALITIES,
            url: 'governanceroom/cihadashboard/locationTopMunicipalities'
        },
        filterParams,
        false
    );


    const queries = [topCnes, managementByYear, byNature, topMunicipalities];
    const isLoading = queries.some((query) => query.isLoading);
    const isError = queries.some((query) => query.isError);
    
    const chartData = {
        topCnes: topCnes.data?.top_cnes || [],
        managementByYear: managementByYear.data?.gestao_por_ano || [],
        byNature: byNature.data?.natureza || [],
        topMunicipalities: topMunicipalities.data?.top_municipios || []
    };

    return (
        <EstablishmentLocationChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters
            }}
        >
            {children}
        </EstablishmentLocationChartsDataContext.Provider>
    );
};

export default EstablishmentLocationChartsDataProvider;
